export const { Users,CreateUser,ViewUsers } = require("./Users");
export {CommunityPermission} from './Communitys';
export { default as SMS } from './SMS';
export { default as CreateSMS } from './SMS/CreateSMS';
export { default as MaintenanceSetup } from './MaintenanceSetup/MaintenanceSetup';
// export  {AccountInfo} from "./RIC/webparts/ric/components/RIC/Accounts/Index";